import { KeyboardEvent, MouseEvent, useCallback, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"


import { AgGridReact } from "ag-grid-react"
import { Content_PRD3020_R01 } from "./Content_PRD3020_R01"
import { defaultPRD3020_R01Dto, PRD3020_R01DetailDto, PRD3020_R01Dto } from "./Dto_PRD3020_R01"
import { SearchSection_PRD3020_R01 } from "./SearchSection_PRD3020_R01"
import { usePRD3020_R01Store } from "./Store_PRD3020_R01"
import { Table_PRD3020_R01 } from "./Table_PRD3020_R01"
import { Modal_PRD3020_R01 } from "./Modal_PRD3020_R01"
import { DetailTable_PRD3020_R01 } from "./DetailTable_PRD3020_R01"
import { useMouseContent } from "src/utils/mouse/mouseContent"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_PRD3020_R01 = () => {
	const { 
		PRD3020_R01List,
		insertPRD3020_R01List,
		modalVisible,
		initData,
	} = usePRD3020_R01Store();
	const { setMessage } = useUiuxStore();
	
	const gridRef = useRef<AgGridReact<PRD3020_R01Dto> | null>(null);
	const detailGridRef = useRef<AgGridReact<PRD3020_R01DetailDto> | null>(null);
	const gridContainerRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const RESIZER = {
		code: 'PRD3020_R01',
		type: 'height',
		storageKey: 'PRD3020_R01-split-height',
		min: 20,
		max: 80,
		default: 60,
	} as const;

	const {
		splitValue,
		handleMouseDown,
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef: gridContainerRef,
	});

	

	const {
		fetchData,
		fetchOne,
		defaultPRD3020_R01Row,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		buttonDisabled,
	} = Content_PRD3020_R01({
		gridRef,
		setMessage,
	});

    const [clickable, setClickable] = useState(true);

	// 상단 '등록' 버튼 전용 핸들러
	const handleInsertClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
		InsertRowHandler({
			event: e,
			dataList: PRD3020_R01List,
			rowData: {...defaultPRD3020_R01Row(), valueIndex: -1},
			insertRow: insertPRD3020_R01List,
			defaultRowData: defaultPRD3020_R01Row(),
			setClickable
		});
	}, [PRD3020_R01List, insertPRD3020_R01List, setClickable]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initData}
		/>
		
		<SearchSection_PRD3020_R01
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div
			className="flex-1 flex flex-col min-h-0 p-[12px] gap-[4px]"
			ref={gridContainerRef}
		>
			<div
				className="w-full min-h-0 flex flex-col"
				style={{ height: `${splitValue}%` }}
			>
				
				<Table_PRD3020_R01
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultPRD3020_R01Row={defaultPRD3020_R01Row()}
					fetchOne={fetchOne}
				/>
			</div>
			<div
				className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 shrink-0"
				onMouseDown={(e: MouseEvent<HTMLDivElement>) => handleMouseDown('UD', e.nativeEvent)}
				onDragStart={(e) => e.preventDefault()}
			/>
			<div
				className="w-full min-h-0 flex flex-col"
				style={{ height: `${100 - splitValue}%` }}
			>
				<DetailTable_PRD3020_R01 gridRef={detailGridRef} />
			</div>
		</div>
		<Message />
		{modalVisible && <Modal_PRD3020_R01 handleSaveClick={handleSaveClick} />}
	</div>
}
